import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Popper } from '@material-ui/core';
import moment from 'moment';
import { useModal } from 'utils';
import { ValidationInput } from 'components';
import { httpRequestsOnSuccessActions, loadAuthActions } from 'store';

export const PmtDate = ({ item, afterSuccess }) => {
  const { open } = useModal();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openBool = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  const pendingDate = item?.bill?.pendingPmtDate;
  const [date, setDate] = useState(pendingDate);
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeDate = async (e) => {
    setDate(e?.target?.value);
    const date = e?.target?.value ? e?.target?.value : null;
    await loadAuthActions.pmtPending(item.id, date);
    dispatch(httpRequestsOnSuccessActions.appendSuccess('PMT_PENDING_DATE_SUCCESS'));
    afterSuccess('noLoad');
    handleClose();
  };

  return (
    <div>
      <button
        style={{ color: pendingDate ? '#438BFE' : '#00C851' }}
        className="pmt-date-btn"
        aria-describedby={id}
        type="button"
        onClick={handleClick}
      >
        {pendingDate ?
          moment(pendingDate).format('MM/DD/YYYY')
          :
          'Add Date'
        }
      </button>

      <Popper
        id={id}
        open={openBool}
        anchorEl={anchorEl}
        className={'status-select-paper-box'}
        onClose={handleClose}
        style={{ position: 'absolute', zIndex: 1200 }}
      >
        <Box className="pmt-date-box">
          <p>Change Date</p>
          <ValidationInput
            variant={'outlined'}
            name={'pmtDate'}
            type={'date'}
            onChange={handleChangeDate}
            value={date ? moment(date).format('YYYY-MM-DD') : date}
            noErrMessage={true}
          />
        </Box>
      </Popper>
      {openBool && <div className="beck-drop" onClick={() => setAnchorEl(null)} />}
    </div>
  );
};